import axios from 'axios'
import { BASE_DEV_URL_PUBLIC, VARNISH_PUBLIC_URL } from "../config/api.config";

const BASE_URL =  BASE_DEV_URL_PUBLIC
const httpNotAuth = axios.create({
  baseURL: BASE_URL,
  headers: {
    Accept: 'application/json',
    authorization: '',
  },
})
export const httpNotAuth2 = axios.create({
  baseURL: VARNISH_PUBLIC_URL,
  headers: {
    Accept: 'application/json',
    authorization: '',
  },
})

export default httpNotAuth
